<template>
    <div class="c-default-overlay is-active">
        <template v-if="!loading">
            <button class="close-button c-overlay-close-button" v-on:click.prevent="closeReveal" aria-label="Close alert" type="button">
                <span aria-hidden="true">&times;</span>
            </button>
            <div class="c-default-overlay-wrapper">
                <h2 class="c-heading-large">{{ translate('frontend.js.reviews.heading') }}</h2>
                <div class="u-relative">
                    <h2 class="c-heading-medium u-margin-bottom-small">Onze recensies</h2>
                    <div class="c-review-wrapper" v-for="review in reviews">
                        <figure class="c-figure-avatar">
                            <img class="c-figure-image" alt="" :src="review.single_file ? changeImageSize(review.single_file.media_path, 80, 80) : '/assets/images/frontend/review_default.png' ">
                        </figure>
                        <div class="c-review">
                            <h3 class="c-heading-small u-no-margin-bottom">{{ review.name }}</h3>
                            <span class="c-review-sub" v-if="review.storage_box">{{ review.storage_box.name }}</span>
                            <p class="c-review-text">“{{ review.description }}”</p>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
    export default {
        name: 'reviews-reveal',
        data() {
            return {
                reviews: [],
                loading: true,
            }
        },
        mounted() {
            this.getReviews();
            this.disableScroll();
        },
        beforeDestroy() {
            this.disableScroll();
        },
        methods: {
            /**
             * Get reviews from the API request
             *
             * @author Rick van der Burg <rick@click.nl>
             * @return void
             */
            getReviews() {
                axios.get('/api/reviews')
                    .then(this.setReviews);
            },
            /**
             * Set the reviews in the property
             *
             * @author Rick van der Burg <rick@click.nl>
             * @return void
             */
            setReviews(response) {
                this.reviews = response.data;
                this.loading = false;
            },
            /**
             * Close the review reveal
             *
             * @author Rick van der Burg <rick@click.nl>
             * @return void
             */
            closeReveal() {
                this.$emit('closeReviewReveal');
            },
            /**
             * Disables the scroll for the body when overlay is open
             *
             * @author Yonita van Oudheusden <yonita@click.nl>
             * @return void
             */
            disableScroll() {
                var $body = $('body');
                // Add class that will disable the scroll on the body 

                if($body.hasClass('u-disable-scroll')) {
                    $body.removeClass('u-disable-scroll');
                } else {
                    $body.addClass('u-disable-scroll');
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/frontend/vue/global/reviews-reveal.vue